import type { ODSNotificationMode } from '@telekom-ods/react-ui-kit';
import { createContext } from 'react';

export interface Message {
  id: number;
  message: string;
  type: ODSNotificationMode;
  title: string;
}

export interface PushPayload {
  message: string;
  type?: ODSNotificationMode;
  title?: string;
}

export interface NotificationReturn {
  id: number;
  dismiss: () => void;
}

export interface NotificationContextType {
  push: (payload: PushPayload) => NotificationReturn;
  remove: (id: number) => void;
  messages: Message[];
}

const defaultNotification: NotificationContextType = {
  push: () => ({
    id: 0,
    dismiss: () => {
      /* empty */
    },
  }),
  remove: () => {
    /* empty */
  },
  messages: [],
};

const NotificationContext = createContext<NotificationContextType>(defaultNotification);

export default NotificationContext;
